{
  "familyId": "SWW-VT-ZWAK-KOF",
  "questions": [
    {
      "id": "SWW-VT-ZWAK-KOF-001",
      "familyId": "SWW-VT-ZWAK-KOF",
      "module": "SpellingWW",
      "tier": 5,
      "levelCode": "E6",
      "group": 6,
      "skill": "verleden_tijd",
      "subSkill": "vt_kofschip",
      "questionType": "multiple_choice",
      "question": "De postbode ... gisteren alle brieven in het park. (spelen → verleden tijd meervoud)",
      "options": ["speelden", "spelen", "speel", "gespeeld"],
      "correctAnswer": 0,
      "stimulusAids": [{"type": "kofschipMnemonic", "data": {"verb": "spelen", "stem": "speel", "lastLetter": "l", "useTE": false, "label": "'t Kofschip Regel"}}],
      "supportAids": [{"type": "rule", "showWhen": "wrong", "data": {"title": "'t Kofschip", "content": "De stam 'speel' eindigt op 'l'. Deze letter staat NIET in 't kofschip, dus gebruik je -de (enkelvoud) of -den (meervoud).", "icon": "lightbulb"}}],
      "conceptId": "past_tense_trigger_word_gisteren",
      "variantIndex": 1,
      "citoDifficulty": 0.22,
      "citoDiscrimination": 0.74,
      "pedagogy": { "dok": 1, "misconceptionTags": [] },
      "feedback": {
        "explanationText": "De postbode speelde — maar hier is het meervoud. De stam van 'spelen' is 'speel'. De laatste letter 'l' staat NIET in 't kofschip (T-K-O-F-S-CH-I-P), dus: speel + den = speelden.",
        "solutionSteps": ["Stam bepalen: spelen − en = speel", "Laatste letter van de stam: 'l'", "'l' staat NIET in 't kofschip → gebruik -de/-den", "Meervoud (wij/zij) → speel + den = speelden"],
        "distractorExplanations": {
          "0": "Goed! 'l' staat niet in 't kofschip → stam + den (meervoud) = speelden.",
          "1": "Je dacht waarschijnlijk dat de tegenwoordige tijd hier past. Maar het signaalwoord 'gisteren' vraagt om verleden tijd. Onthoud: 'gisteren' = verleden tijd.",
          "2": "Je dacht waarschijnlijk dat de stam het antwoord is. Maar 'speel' is alleen de stam — bij verleden tijd meervoud voeg je -den toe: speelden. Onthoud: stam ≠ verleden tijd.",
          "3": "Je dacht waarschijnlijk dat het voltooid deelwoord hier past. Maar 'gespeeld' hoort bij 'hebben gespeeld'. Hier staat geen hulpwerkwoord, dus gewoon verleden tijd: speelden. Onthoud: geen hulpwerkwoord = geen voltooid deelwoord."
        }
      }
    },
    {
      "id": "SWW-VT-ZWAK-KOF-002",
      "familyId": "SWW-VT-ZWAK-KOF",
      "module": "SpellingWW",
      "tier": 5,
      "levelCode": "E6",
      "group": 6,
      "skill": "verleden_tijd",
      "subSkill": "vt_kofschip",
      "questionType": "multiple_choice",
      "question": "De bakker ... vorige week de auto. (poetsen → verleden tijd enkelvoud)",
      "options": ["poetste", "poetsde", "poetsen", "gepoetst"],
      "correctAnswer": 0,
      "stimulusAids": [{"type": "kofschipMnemonic", "data": {"verb": "poetsen", "stem": "poets", "lastLetter": "s", "useTE": true, "label": "'t Kofschip Regel"}}],
      "supportAids": [{"type": "rule", "showWhen": "wrong", "data": {"title": "'t Kofschip", "content": "De stam 'poets' eindigt op 's'. Deze letter zit WEL in 't kofschip, dus gebruik je -te.", "icon": "lightbulb"}}],
      "conceptId": "past_tense_kofschip_rule",
      "variantIndex": 2,
      "citoDifficulty": 0.28,
      "citoDiscrimination": 0.72,
      "pedagogy": { "dok": 1, "misconceptionTags": [] },
      "feedback": {
        "explanationText": "De bakker poetste de auto. De stam van 'poetsen' is 'poets'. De laatste letter 's' zit WEL in 't kofschip (T-K-O-F-S-CH-I-P). Dus: poets + te = poetste.",
        "solutionSteps": ["Stam bepalen: poetsen − en = poets", "Laatste letter van de stam: 's'", "'s' zit WEL in 't kofschip → gebruik -te/-ten", "Enkelvoud (hij) → poets + te = poetste"],
        "distractorExplanations": {
          "0": "Goed! 's' zit in 't kofschip → stam + te = poetste.",
          "1": "Je dacht waarschijnlijk dat het -de wordt. Maar de 's' in 'poets' zit WEL in 't kofschip, dus het wordt -te, niet -de. Onthoud: kofschip-letter → -te.",
          "2": "Je dacht waarschijnlijk dat de tegenwoordige tijd hier past. Maar 'vorige week' is een signaalwoord voor verleden tijd. Onthoud: 'vorige week' = verleden tijd.",
          "3": "Je dacht waarschijnlijk dat het voltooid deelwoord hier past. Maar 'gepoetst' hoort bij 'heeft gepoetst'. Hier staat geen hulpwerkwoord. Onthoud: geen hulpwerkwoord = gewoon verleden tijd."
        }
      }
    },
    {
      "id": "SWW-VT-ZWAK-KOF-003",
      "familyId": "SWW-VT-ZWAK-KOF",
      "module": "SpellingWW",
      "tier": 5,
      "levelCode": "E6",
      "group": 6,
      "skill": "verleden_tijd",
      "subSkill": "vt_kofschip",
      "questionType": "multiple_choice",
      "question": "De schilder ... gisteren de muur. (verven → verleden tijd enkelvoud)",
      "options": ["verfde", "verfte", "verfden", "geverfd"],
      "correctAnswer": 0,
      "stimulusAids": [{"type": "kofschipMnemonic", "data": {"verb": "verven", "stem": "verf", "lastLetter": "f", "useTE": false, "label": "'t Kofschip — uitzondering: verven"}}],
      "supportAids": [{"type": "rule", "showWhen": "wrong", "data": {"title": "'t Kofschip — lastig geval", "content": "De stam 'verf' eindigt op 'f'. De 'f' zit WEL in 't kofschip, dus je verwacht -te. Maar 'verfte' klinkt raar — in de praktijk schrijven we 'verfde'. Dit is een uitzondering!", "icon": "lightbulb"}}],
      "conceptId": "past_tense_kofschip_exception_verf",
      "variantIndex": 3,
      "citoDifficulty": 0.38,
      "citoDiscrimination": 0.68,
      "pedagogy": { "dok": 2, "misconceptionTags": [] },
      "feedback": {
        "explanationText": "De schilder verfde de muur. De stam van 'verven' is 'verf'. De 'f' zit in 't kofschip, dus je verwacht -te. Maar 'verfte' klinkt onnatuurlijk — we schrijven 'verfde'. Dit is een bekende uitzondering op de kofschip-regel.",
        "solutionSteps": ["Stam bepalen: verven − en = verf", "Laatste letter: 'f' → zit in 't kofschip", "Maar 'verfte' klinkt raar → uitzondering", "We schrijven: verfde"],
        "distractorExplanations": {
          "0": "Goed! 'Verfde' is correct — dit is een uitzondering op de kofschip-regel.",
          "1": "Je dacht waarschijnlijk dat de kofschip-regel hier gewoon geldt. De 'f' zit inderdaad in 't kofschip, maar 'verfte' klinkt onnatuurlijk. We schrijven 'verfde'. Onthoud: 'verven' is een uitzondering.",
          "2": "Je dacht waarschijnlijk dat het meervoud is. Maar 'de schilder' is enkelvoud (hij), dus -de, niet -den. Onthoud: hij/zij = enkelvoud → -de.",
          "3": "Je dacht waarschijnlijk dat het voltooid deelwoord hier past. Maar 'geverfd' hoort bij 'heeft geverfd'. Hier staat geen hulpwerkwoord. Onthoud: geen hulpwerkwoord = gewoon verleden tijd."
        }
      }
    },
    {
      "id": "SWW-VT-ZWAK-KOF-004",
      "familyId": "SWW-VT-ZWAK-KOF",
      "module": "SpellingWW",
      "tier": 5,
      "levelCode": "E6",
      "group": 6,
      "skill": "verleden_tijd",
      "subSkill": "vt_kofschip",
      "questionType": "multiple_choice",
      "question": "De tuinman ... vorige maand de heg. (knippen → verleden tijd enkelvoud)",
      "options": ["knipte", "knipde", "knippen", "geknipt"],
      "correctAnswer": 0,
      "stimulusAids": [{"type": "kofschipMnemonic", "data": {"verb": "knippen", "stem": "knip", "lastLetter": "p", "useTE": true, "label": "'t Kofschip Regel"}}],
      "supportAids": [{"type": "rule", "showWhen": "wrong", "data": {"title": "'t Kofschip", "content": "De stam 'knip' eindigt op 'p'. De 'p' zit WEL in 't kofschip (de laatste letter!), dus gebruik je -te.", "icon": "lightbulb"}}],
      "conceptId": "past_tense_kofschip_p",
      "variantIndex": 4,
      "citoDifficulty": 0.25,
      "citoDiscrimination": 0.73,
      "pedagogy": { "dok": 1, "misconceptionTags": [] },
      "feedback": {
        "explanationText": "De tuinman knipte de heg. De stam van 'knippen' is 'knip'. De laatste letter 'p' zit WEL in 't kofschip (T-K-O-F-S-CH-I-P — de P is de laatste letter!). Dus: knip + te = knipte.",
        "solutionSteps": ["Stam bepalen: knippen − pen = knip", "Laatste letter van de stam: 'p'", "'p' zit WEL in 't kofschip → gebruik -te", "Enkelvoud → knip + te = knipte"],
        "distractorExplanations": {
          "0": "Goed! 'p' zit in 't kofschip → stam + te = knipte.",
          "1": "Je dacht waarschijnlijk dat het -de wordt. Maar de 'p' in 'knip' zit WEL in 't kofschip, dus het wordt -te, niet -de. Onthoud: kofschip-letter → -te.",
          "2": "Je dacht waarschijnlijk dat de tegenwoordige tijd hier past. Maar 'vorige maand' is een signaalwoord voor verleden tijd. Onthoud: 'vorige maand' = verleden tijd.",
          "3": "Je dacht waarschijnlijk dat het voltooid deelwoord hier past. Maar 'geknipt' hoort bij 'heeft geknipt'. Hier staat geen hulpwerkwoord. Onthoud: geen hulpwerkwoord = gewoon verleden tijd."
        }
      }
    },
    {
      "id": "SWW-VT-ZWAK-KOF-005",
      "familyId": "SWW-VT-ZWAK-KOF",
      "module": "SpellingWW",
      "tier": 5,
      "levelCode": "E6",
      "group": 6,
      "skill": "verleden_tijd",
      "subSkill": "vt_kofschip",
      "questionType": "multiple_choice",
      "question": "De zwemleraar ... de kinderen gisteren. (leren → verleden tijd enkelvoud)",
      "options": ["leerde", "leertte", "leerte", "geleerd"],
      "correctAnswer": 0,
      "stimulusAids": [{"type": "kofschipMnemonic", "data": {"verb": "leren", "stem": "leer", "lastLetter": "r", "useTE": false, "label": "'t Kofschip Regel"}}],
      "supportAids": [{"type": "rule", "showWhen": "wrong", "data": {"title": "'t Kofschip", "content": "De stam 'leer' eindigt op 'r'. De 'r' staat NIET in 't kofschip, dus gebruik je -de.", "icon": "lightbulb"}}],
      "conceptId": "past_tense_not_kofschip_r",
      "variantIndex": 5,
      "citoDifficulty": 0.20,
      "citoDiscrimination": 0.76,
      "pedagogy": { "dok": 1, "misconceptionTags": [] },
      "feedback": {
        "explanationText": "De zwemleraar leerde de kinderen. De stam van 'leren' is 'leer'. De laatste letter 'r' staat NIET in 't kofschip (T-K-O-F-S-CH-I-P). Dus: leer + de = leerde.",
        "solutionSteps": ["Stam bepalen: leren − en = leer", "Laatste letter van de stam: 'r'", "'r' staat NIET in 't kofschip → gebruik -de/-den", "Enkelvoud → leer + de = leerde"],
        "distractorExplanations": {
          "0": "Goed! 'r' staat niet in 't kofschip → stam + de = leerde.",
          "1": "Je dacht waarschijnlijk dat je -tte toevoegt. Maar dat bestaat niet — je kiest altijd tussen -te of -de. De 'r' staat niet in 't kofschip, dus -de: leerde. Onthoud: alleen -te of -de.",
          "2": "Je dacht waarschijnlijk dat het -te wordt. Maar de 'r' in 'leer' staat NIET in 't kofschip, dus het wordt -de, niet -te. Onthoud: niet in kofschip → -de.",
          "3": "Je dacht waarschijnlijk dat het voltooid deelwoord hier past. Maar 'geleerd' hoort bij 'heeft geleerd'. Hier staat geen hulpwerkwoord. Onthoud: geen hulpwerkwoord = gewoon verleden tijd."
        }
      }
    },
    {
      "id": "SWW-VT-ZWAK-KOF-006",
      "familyId": "SWW-VT-ZWAK-KOF",
      "module": "SpellingWW",
      "tier": 5,
      "levelCode": "E6",
      "group": 6,
      "skill": "verleden_tijd",
      "subSkill": "vt_kofschip",
      "questionType": "multiple_choice",
      "question": "De dierenoppassers ... gisteren de honden uit. (laten → verleden tijd meervoud)",
      "options": ["lieten", "laatten", "lietten", "gelaten"],
      "correctAnswer": 0,
      "stimulusAids": [{"type": "kofschipMnemonic", "data": {"verb": "laten", "stem": "laat", "lastLetter": "t", "useTE": false, "label": "Let op: 'laten' is een STERK werkwoord — de kofschip-regel geldt hier niet!"}}],
      "supportAids": [{"type": "rule", "showWhen": "wrong", "data": {"title": "Sterk werkwoord — let op!", "content": "'Laten' is een sterk werkwoord. De verleden tijd is 'liet' (enkelvoud) of 'lieten' (meervoud). Sterke werkwoorden volgen NIET de kofschip-regel — je moet ze uit je hoofd leren.", "icon": "lightbulb"}}],
      "conceptId": "past_tense_strong_contrast",
      "variantIndex": 6,
      "citoDifficulty": 0.35,
      "citoDiscrimination": 0.70,
      "pedagogy": { "dok": 2, "misconceptionTags": [] },
      "feedback": {
        "explanationText": "De dierenoppassers lieten de honden uit. 'Laten' is een sterk werkwoord — het volgt NIET de kofschip-regel. De verleden tijd is 'liet' (enkelvoud) of 'lieten' (meervoud). Dit moet je uit je hoofd leren.",
        "solutionSteps": ["'Laten' is een sterk werkwoord", "Sterke werkwoorden volgen niet de kofschip-regel", "Verleden tijd: liet (enkelvoud) / lieten (meervoud)", "Meervoud → lieten"],
        "distractorExplanations": {
          "0": "Goed! 'Laten' is een sterk werkwoord → verleden tijd meervoud = lieten.",
          "1": "Je dacht waarschijnlijk dat je de kofschip-regel toepast op 'laten'. Maar 'laten' is een sterk werkwoord — het verandert van klank (a → ie). Onthoud: sterke werkwoorden volgen niet de kofschip-regel.",
          "2": "Je dacht waarschijnlijk dat je -tten toevoegt. Maar dat bestaat niet — 'laten' is een sterk werkwoord met verleden tijd 'liet/lieten'. Onthoud: sterke werkwoorden moet je uit je hoofd leren.",
          "3": "Je dacht waarschijnlijk dat het voltooid deelwoord hier past. Maar 'gelaten' hoort bij 'hebben gelaten'. Hier staat geen hulpwerkwoord. Onthoud: geen hulpwerkwoord = gewoon verleden tijd."
        }
      }
    },
    {
      "id": "SWW-VT-ZWAK-KOF-007",
      "familyId": "SWW-VT-ZWAK-KOF",
      "module": "SpellingWW",
      "tier": 5,
      "levelCode": "E6",
      "group": 6,
      "skill": "verleden_tijd",
      "subSkill": "vt_kofschip",
      "questionType": "fill_in",
      "question": "De kok ... gisteren het eten. (koken → verleden tijd enkelvoud) Typ het werkwoord.",
      "options": [],
      "correctAnswer": 0,
      "data": {"acceptedAnswers": ["kookte"], "caseSensitive": false, "placeholder": "..."},
      "stimulusAids": [{"type": "kofschipMnemonic", "data": {"verb": "koken", "stem": "kook", "lastLetter": "k", "useTE": true, "label": "'t Kofschip Regel"}}],
      "supportAids": [{"type": "rule", "showWhen": "wrong", "data": {"title": "'t Kofschip", "content": "De stam van 'koken' is 'kook'. De laatste letter 'k' zit WEL in 't kofschip (T-K-O-F-S-CH-I-P). Dus: kook + te = kookte.", "icon": "lightbulb"}}],
      "conceptId": "past_tense_kofschip_k_fill",
      "variantIndex": 7,
      "citoDifficulty": 0.30,
      "citoDiscrimination": 0.73,
      "pedagogy": { "dok": 1, "misconceptionTags": [] },
      "feedback": {
        "explanationText": "De stam van 'koken' is 'kook'. De 'k' zit in 't kofschip → kook + te = kookte.",
        "solutionSteps": ["Stam: koken − en = kook", "Laatste letter: 'k' → zit in 't kofschip", "Enkelvoud → kook + te = kookte"]
      }
    },
    {
      "id": "SWW-VT-ZWAK-KOF-008",
      "familyId": "SWW-VT-ZWAK-KOF",
      "module": "SpellingWW",
      "tier": 5,
      "levelCode": "E6",
      "group": 6,
      "skill": "verleden_tijd",
      "subSkill": "vt_kofschip",
      "questionType": "fill_in",
      "question": "Wij ... gisteren de hele dag. (werken → verleden tijd meervoud) Typ het werkwoord.",
      "options": [],
      "correctAnswer": 0,
      "data": {"acceptedAnswers": ["werkten"], "caseSensitive": false, "placeholder": "..."},
      "stimulusAids": [{"type": "kofschipMnemonic", "data": {"verb": "werken", "stem": "werk", "lastLetter": "k", "useTE": true, "label": "'t Kofschip Regel"}}],
      "supportAids": [{"type": "rule", "showWhen": "wrong", "data": {"title": "'t Kofschip — meervoud", "content": "De stam van 'werken' is 'werk'. De 'k' zit in 't kofschip → -te (enkelvoud) of -ten (meervoud). Wij = meervoud → werk + ten = werkten.", "icon": "lightbulb"}}],
      "conceptId": "past_tense_kofschip_k_plural_fill",
      "variantIndex": 8,
      "citoDifficulty": 0.32,
      "citoDiscrimination": 0.72,
      "pedagogy": { "dok": 1, "misconceptionTags": [] },
      "feedback": {
        "explanationText": "De stam van 'werken' is 'werk'. De 'k' zit in 't kofschip → -ten (meervoud). Werk + ten = werkten.",
        "solutionSteps": ["Stam: werken − en = werk", "Laatste letter: 'k' → zit in 't kofschip", "Meervoud (wij) → werk + ten = werkten"]
      }
    },
    {
      "id": "SWW-VT-ZWAK-KOF-009",
      "familyId": "SWW-VT-ZWAK-KOF",
      "module": "SpellingWW",
      "tier": 5,
      "levelCode": "E6",
      "group": 6,
      "skill": "verleden_tijd",
      "subSkill": "vt_kofschip",
      "questionType": "fill_in",
      "question": "De hond ... gisteren in de tuin. (graven → verleden tijd enkelvoud) Typ het werkwoord.",
      "options": [],
      "correctAnswer": 0,
      "data": {"acceptedAnswers": ["groef", "Groef"], "caseSensitive": false, "placeholder": "..."},
      "stimulusAids": [{"type": "kofschipMnemonic", "data": {"verb": "graven", "stem": "graaf", "lastLetter": "f", "useTE": false, "label": "Let op: 'graven' is een STERK werkwoord — de kofschip-regel geldt hier niet!"}}],
      "supportAids": [{"type": "rule", "showWhen": "wrong", "data": {"title": "Sterk werkwoord — let op!", "content": "'Graven' is een sterk werkwoord. De verleden tijd is 'groef' (enkelvoud) of 'groeven' (meervoud). Sterke werkwoorden veranderen van klank (a → oe) en volgen NIET de kofschip-regel.", "icon": "lightbulb"}}],
      "conceptId": "past_tense_strong_contrast_fill",
      "variantIndex": 9,
      "citoDifficulty": 0.42,
      "citoDiscrimination": 0.69,
      "pedagogy": { "dok": 2, "misconceptionTags": [] },
      "feedback": {
        "explanationText": "'Graven' is een sterk werkwoord — het verandert van klank. De verleden tijd enkelvoud is 'groef' (niet 'graafde' of 'graaftte'). Dit moet je uit je hoofd leren.",
        "solutionSteps": ["'Graven' is een sterk werkwoord", "Klankverandering: a → oe", "Verleden tijd: groef (enkelvoud) / groeven (meervoud)", "Antwoord: groef"]
      }
    },
    {
      "id": "SWW-VT-ZWAK-KOF-010",
      "familyId": "SWW-VT-ZWAK-KOF",
      "module": "SpellingWW",
      "tier": 5,
      "levelCode": "E6",
      "group": 6,
      "skill": "verleden_tijd",
      "subSkill": "vt_kofschip",
      "questionType": "error_spotting",
      "question": "Zoek de werkwoordfouten in deze zinnen en verbeter ze.",
      "options": [],
      "correctAnswer": 0,
      "data": {
        "text": "De kok kookte gisteren een lekker gerecht. De schilder verfte de muur. De bakker werkde de hele dag.",
        "errors": [
          {
            "word": "verfte",
            "position": 8,
            "correction": "verfde",
            "explanation": "'Verven' is een uitzondering: de stam 'verf' eindigt op 'f' (kofschip → -te), maar 'verfte' klinkt onnatuurlijk. De gebruikelijke vorm is 'verfde'."
          },
          {
            "word": "werkde",
            "position": 14,
            "correction": "werkte",
            "explanation": "De stam 'werk' eindigt op 'k'. De 'k' zit in 't kofschip → -te, niet -de. Werk + te = werkte."
          }
        ]
      },
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "kofschipMnemonic",
          "data": {
            "verb": "werken",
            "stem": "werk",
            "lastLetter": "k",
            "useTE": true,
            "label": "'t Kofschip Regel"
          },
          "showWhen": "wrong"
        },
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "'t Kofschip — fouten herkennen",
            "content": "Check elke verleden tijd: 1) Bepaal de stam. 2) Kijk naar de laatste letter. 3) Staat die in 't kofschip? → -te/-ten. Zo niet → -de/-den. Let op uitzonderingen zoals 'verven' → 'verfde'.",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "past_tense_kofschip_error_spotting",
      "variantIndex": 10,
      "citoDifficulty": 0.40,
      "citoDiscrimination": 0.70,
      "pedagogy": { "dok": 3, "misconceptionTags": [] },
      "feedback": {
        "explanationText": "Fout 1: 'verfte' → moet 'verfde' zijn. 'Verven' is een uitzondering: hoewel 'f' in kofschip zit, klinkt 'verfte' onnatuurlijk. De gebruikelijke vorm is 'verfde'. Fout 2: 'werkde' → moet 'werkte' zijn. De stam 'werk' eindigt op 'k', en 'k' zit in 't kofschip → -te. 'Kookte' is correct (stam 'kook', k in kofschip → -te).",
        "solutionSteps": [
          "Zin 1: 'kookte' → stam 'kook', k in kofschip → -te ✓ (correct)",
          "Zin 2: 'verfte' → uitzondering! Moet 'verfde' zijn (verfte klinkt onnatuurlijk)",
          "Zin 3: 'werkde' → stam 'werk', k in kofschip → -te, niet -de → 'werkte'"
        ]
      }
    }
  ]
}